// Getting a note into the buyer's hands — download, or WhatsApp with the
// hosted link pre-typed. Shared by the row buttons and the money modal so
// the two can never behave differently.

import { carsTeamApi } from '../../api/carsApi';
import { waBookingLink, waShareLink } from './carsMoney.js';

export const saveBlob = (data, filename) => {
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

const tag = (car) => String(car.registration_number || `car-${car.id}`).toLowerCase();

export const downloadBookingNote = async (car) => {
  const { data } = await carsTeamApi.downloadBookingNote(car.id);
  saveBlob(data, `capcars-booking-${tag(car)}.pdf`);
};

export const downloadDeliveryNote = async (car) => {
  const { data } = await carsTeamApi.downloadDeliveryNote(car.id);
  saveBlob(data, `capcars-delivery-${tag(car)}.pdf`);
};

const NO_PHONE = 'No phone on the sale — download the note and share it yourself.';

/** Host the current booking note, open WhatsApp with it pre-typed. If hosting
 *  is off the PDF downloads instead — attach it by hand, nothing lost. */
export const whatsAppBookingNote = async (car) => {
  const { data } = await carsTeamApi.shareBookingNote(car.id);
  const link = waBookingLink(car, car.sale, data?.url || '');
  if (!link) throw new Error(NO_PHONE);
  if (!data?.url) await downloadBookingNote(car);
  window.open(link, '_blank', 'noopener');
};

/** The delivery note was hosted at handover — just open WhatsApp with it. */
export const whatsAppDeliveryNote = (car) => {
  const link = waShareLink(car, car.sale);
  if (!link) throw new Error(NO_PHONE);
  window.open(link, '_blank', 'noopener');
};
